import { Component, OnInit } from '@angular/core';
import { ComplaintsService } from '../complaints.service';
import { SharedService } from '../../shared/shared.service';
import { ToastService } from '../../core/toast/toast.service';
import { ActivatedRoute, Router } from '@angular/router';
import { LanguageService } from '../../core/language/language.service';
import { ComplaintDetail } from '../../core/models/complaint/complaint-detail';
import { DropdownItem } from '../../core/models/dropdown-item';
import { ComplaintComment } from '../../core/models/complaint/complaint-comment';
import { AssignComplaint } from '../../core/models/complaint/assign-complaint';
import { ComplaintCommentFile } from '../../core/models/complaint/complaint-comment-file';
import { ComplaintAnswer } from '../../core/models/complaint/complaint-answer';
import { CONFIG } from '../../core/config';
import { ComplaintConfigurationService } from '../../admin/complaint-configuration/complaint-configuration.service';
import { Images } from '../../core/models/complaint/images';
declare var ol: any;

@Component({
  selector: 'app-my-complaint-detail',
  templateUrl: './my-complaint-detail.component.html',
  styleUrls: ['./my-complaint-detail.component.css']
})
export class MyComplaintDetailComponent implements OnInit {
    public pathname: string;
    private languageID: number;
    public complaint: ComplaintDetail;  //TODO promijeniti sve koji se koriste negdje drugo u public
    public categories: DropdownItem[] = [];
    public statuses: DropdownItem[] = [];
    public organizations: DropdownItem[] = [];
    public newComment: ComplaintComment;
    public assignComplaint: AssignComplaint;
    public complaintCommentFiles: ComplaintCommentFile;
    public complaintCommentFileNames: string[] = [];
    public newAnswer: ComplaintAnswer;
    public imagesFromDb: Images[] = [];

    public showNewCommentFields: boolean = false;
    public markAsInappropriate: boolean = false;
    public showAnswerSection: boolean = false;
    public showAnswerFileAdd: boolean = false;

    public id: number = 0;

    public selectedFiles: File[] = [];

    map: any;

    public displayedComments: any[];

    public offset: number = 1;
    public limit: number = 5;
    public size: number = 0;
    public pageNum: number = 1;
    public pageSize: number = this.limit;
    public isDesc: boolean = true;
    public column: string = "";
    public commentsLength: number = 0;

    public imgSrc:string;

    constructor(private _complaintService: ComplaintsService,
        private _complaintConfiguratioService: ComplaintConfigurationService,
        private _toastService: ToastService,
        private _sharedService: SharedService,
        private _route: ActivatedRoute,
        private _router: Router,
        private _languageService: LanguageService) {
        this.languageID = _languageService.selectedLanguageId;
        this.complaint = new ComplaintDetail();
        this.newComment = new ComplaintComment();
        this.assignComplaint = new AssignComplaint();
        this.newAnswer = new ComplaintAnswer();
        this.commentsLength = this.complaint.complaintComment != null ? this.complaint.complaintComment.length : 0;
        this.displayedComments = [];
        this._sharedService.getAllCategoriesForDropdown(0, true, this.languageID).subscribe(result => {
            this.categories = result;
        });
        this._sharedService.getAllOrganizationalUnitsForDropdown(0, true, this.languageID).subscribe(result => {
            this.organizations = result;
        });
    }

    ngOnInit() {
        this.pathname = location.pathname;

        this._route.params.subscribe(params => {
            let id = +params['id'];
            if (!isNaN(id) && id > 0) {
                this.getComplaintById(id);
                //this.getComplaintCommentsByComplaintId(id);
            }
        });

        this.newComment.comment = null;

        //this.map = new ol.Map({
        //    target: 'map',
        //    controls: ol.control.defaults({
        //        attributionOptions: {
        //            collapsible: false
        //        }
        //    }),
        //    layers: [
        //        new ol.layer.Tile({
        //            source: new ol.source.OSM()
        //        })
        //    ],
        //    view: new ol.View({
        //        center: ol.proj.fromLonLat([CONFIG.coordinates.gpsx, CONFIG.coordinates.gpsy]),
        //        maxZoom: 18,
        //        zoom: 16
        //    })
        //});
    }

    onImageClick(event){
        const imgElem = event.target;
        var target = event.target || event.srcElement || event.currentTarget;
        var srcAttr = target.attributes.src;
        this.imgSrc = srcAttr.nodeValue;
    }

    getComplaintById(id: number) {
        this._complaintService.getMyComplaintByID(id, this.languageID).subscribe(result => {
            this.complaint = result;
            this.displayedComments = this.complaint.complaintComment;
            this.size = this.complaint.complaintComment.length;
            document.getElementById("mapShow").innerHTML = '&nbsp;';
            document.getElementById("mapShow").innerHTML = '<div style="height:200px!important" id="map" class="map"></div>';
            if (this.complaint.gpsx != null && this.complaint.gpsy != null) {
                this.map = new ol.Map({
                    target: 'map',
                    controls: ol.control.defaults({
                        attributionOptions: {
                            collapsible: false
                        }
                    }),
                    layers: [
                        new ol.layer.Tile({
                            source: new ol.source.OSM()
                        })
                    ],
                    view: new ol.View({
                        center: ol.proj.fromLonLat([this.complaint.gpsx, this.complaint.gpsy]),
                        maxZoom: 20,
                        zoom: 18
                    })
                });
            }
            else {
                this.map = new ol.Map({
                    target: 'map',
                    controls: ol.control.defaults({
                        attributionOptions: {
                            collapsible: false
                        }
                    }),
                    layers: [
                        new ol.layer.Tile({
                            source: new ol.source.OSM()
                        })
                    ],
                    view: new ol.View({
                        center: ol.proj.fromLonLat([CONFIG.coordinates.gpsx, CONFIG.coordinates.gpsy]),
                        maxZoom: 18,
                        zoom: 16
                    })
                });
            }
            this.drawLocationMarker();
            this._complaintService.getImagesByComplaintID(this.complaint.id).subscribe(result => {
                this.imagesFromDb = result;
            });
        });
    }

    drawLocationMarker() {
        const features = [];
        const iconFeature = new ol.Feature({
            geometry: new ol.geom.Point(ol.proj.transform([this.complaint.gpsx, this.complaint.gpsy], 'EPSG:4326', 'EPSG:3857'))
        });

        const iconStyle = new ol.style.Style({
            image: new ol.style.Icon(({
                anchor: [0.5, 1],
                src: 'http://cdn.mapmarker.io/api/v1/pin?text=P&size=40&hoffset=1'
            }))
        });

        iconFeature.setStyle(iconStyle);
        features.push(iconFeature);

        const vectorSource = new ol.source.Vector({
            features: features
        });

        const markerVectorLayer = new ol.layer.Vector({
            source: vectorSource,
        });

        this.map.addLayer(markerVectorLayer);
    }


    //getComplaintCommentsByComplaintId(id: number) {
    //    this._complaintService.getComplaintCommentsByComplaintId(id, this.languageID).subscribe(result => {
    //        this.comments = result;
    //    });
    //}

    downloadFile(id: number, docName: string, docNameOriginal: string, extension: string) {
        let success = false;
        let fileName = docName + extension;

        return this._complaintService.downloadFile(id, this.languageID).subscribe(result => {
            try {
                var blob = new Blob([result], { type: this._sharedService.getContentType(extension) });
                if (navigator.msSaveBlob)
                    navigator.msSaveBlob(blob, docNameOriginal);
                else {
                    var saveBlob = navigator.msSaveBlob;
                    if (saveBlob === undefined) throw "Not supported";
                    saveBlob(blob, docNameOriginal);
                }
                success = true;
            } catch (ex) { }

            if (!success) {
                var urlCreator = window.URL;
                if (urlCreator) {
                    var link = document.createElement('a');
                    if ('download' in link) {
                        try {
                            // Prepare a blob URL
                            var blob = new Blob([result], { type: this._sharedService.getContentType(extension) });
                            var url = urlCreator.createObjectURL(blob);
                            link.setAttribute('href', url);
                            link.setAttribute("download", docNameOriginal);

                            var event = document.createEvent('MouseEvent');
                            event.initMouseEvent('click', true, true, window, 1, 0, 0, 0, 0, false, false, false, false, 0, null);
                            link.dispatchEvent(event);
                            success = true;
                        } catch (ex) { }
                    }
                }

                if (!success) {
                    try {
                        var blob = new Blob([result], { type: this._sharedService.getContentType(extension) });
                        var url = urlCreator.createObjectURL(blob);
                        window.open(url, "_blank");
                        success = true;
                    } catch (ex) { }
                }
            }
        });
    }

    onLimitChange(newLimit: number) {
        this.offset = 1;
        this.limit = newLimit;
        this.pageNum = 1;
        this.pageSize = +newLimit;
        this.setDisplayedComments();
    }

    onPageChange(offset: number) {
        this.offset = offset;
        this.pageNum = Math.floor(offset / this.limit) + 1;
        this.setDisplayedComments();
    }

    sort(column: string) {
        this.column = column;
        this.isDesc = !this.isDesc;
        this.pageNum = 1;
        this.offset = 1;
        if (this.column == "comment") {
            const asc = this.isDesc ? 1 : -1;
            this.complaint.complaintComment.sort((n1, n2) => n1.comment > n2.comment ? 1 * asc : -1 * asc);
        }
        if (this.column == "userName") {
            const asc = this.isDesc ? 1 : -1;
            this.complaint.complaintComment.sort((n1, n2) => n1.userName > n2.userName ? 1 * asc : -1 * asc);
        }
        if (this.column == "dateCreated") {
            const asc = this.isDesc ? 1 : -1;
            this.complaint.complaintComment.sort((n1, n2) => n1.dateCreated > n2.dateCreated ? 1 * asc : -1 * asc);
        }

        this.setDisplayedComments();
    }

    setDisplayedComments() {
        this.displayedComments = [];
        if (this.size > 0) {
            const skip = (this.pageNum - 1) * this.pageSize;
            if (this.size > skip) {
                var take = this.size > skip + this.pageSize ? skip + this.pageSize : this.size;
                for (let i = skip; i < take; i++) {
                    this.displayedComments.push(this.complaint.complaintComment[i]);
                }
            }
        }
    }

    addNewComment() {
        this.showNewCommentFields = !this.showNewCommentFields;
    }

    fileAdded(event) {
        if (event.target.files.length) {
            for (let i = 0; i < event.target.files.length; i++) {
                this.selectedFiles.push(<File>event.target.files[i]);
            }
        }
    }

    deleteFile(i) {
        this.selectedFiles.splice(i, 1);
    }


    saveNewComment() {
        //this.showNewCommentFields = !this.showNewCommentFields;

        this.newComment.complaintId = this.complaint.id;
        this.newComment.languageId = this.languageID;
        this.newComment.active = false;
        this.newComment.inappropriate = false;



        if (this.newComment.comment != null || this.newComment.comment != "") {
            this._complaintService.addNewComplaintComment(this.newComment).subscribe(result => {
                var comments = result;

                const complaintCommentFile = new ComplaintCommentFile();
                complaintCommentFile.complaintCommentId = comments;

                const formData = new FormData();
                Array.from(this.selectedFiles).forEach(file => formData.append('file', file));
                formData.append('data', JSON.stringify(complaintCommentFile));

                this._complaintService.uploadComplaintCommentFiles(formData).subscribe(result => {

                    //var snimio = result;
                    //if (snimio == true)
                    this.closeNewComment();
                    this.getComplaintById(this.complaint.id);
                    this.closeNewComment();
                });
                this.closeNewComment();
                this.getComplaintById(this.complaint.id);
            });
        }

    }

    closeNewComment() {
        this.showNewCommentFields = !this.showNewCommentFields;
        this.newComment.comment = null;
        this.selectedFiles = [];
    }

    downloadAnswerFile(id: number, docName: string, docNameOriginal: string, extension: string) {
        let success = false;
        let fileName = docName + extension;

        return this._complaintService.downloadAnswerFile(id, this.languageID).subscribe(result => {
            try {
                var blob = new Blob([result], { type: this._sharedService.getContentType(extension) });
                if (navigator.msSaveBlob)
                    navigator.msSaveBlob(blob, docNameOriginal);
                else {
                    var saveBlob = navigator.msSaveBlob;
                    if (saveBlob === undefined) throw "Not supported";
                    saveBlob(blob, docNameOriginal);
                }
                success = true;
            } catch (ex) { }

            if (!success) {
                var urlCreator = window.URL;
                if (urlCreator) {
                    var link = document.createElement('a');
                    if ('download' in link) {
                        try {
                            // Prepare a blob URL
                            var blob = new Blob([result], { type: this._sharedService.getContentType(extension) });
                            var url = urlCreator.createObjectURL(blob);
                            link.setAttribute('href', url);
                            link.setAttribute("download", docNameOriginal);

                            var event = document.createEvent('MouseEvent');
                            event.initMouseEvent('click', true, true, window, 1, 0, 0, 0, 0, false, false, false, false, 0, null);
                            link.dispatchEvent(event);
                            success = true;
                        } catch (ex) { }
                    }
                }

                if (!success) {
                    try {
                        var blob = new Blob([result], { type: this._sharedService.getContentType(extension) });
                        var url = urlCreator.createObjectURL(blob);
                        window.open(url, "_blank");
                        success = true;
                    } catch (ex) { }
                }
            }
        });
    }

}
